import { useEffect, useState } from "react";

const LOGO_URL =
  "https://avatar.setmore.com/files/img/fovdzFZhSBo4/2e15c99f-fac5-418f-859b-6cf7b5a71ea5.jpeg?crop=1290%3B1290%3B0%3B499&w=288&h=288";

const DISPLAY_MS = 2000;
const FADE_MS = 500;

/** Full-screen intro loader: logo + circular progress (~2s), then fade out. */
export function LoadingScreen({ onFinish }) {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setExiting(true), DISPLAY_MS);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!exiting) return;
    const t = setTimeout(() => onFinish?.(), FADE_MS);
    return () => clearTimeout(t);
  }, [exiting, onFinish]);

  return (
    <div
      className={`loading-screen-root fixed inset-0 z-[10000] flex flex-col items-center justify-center bg-[#f7f5f0] transition-opacity duration-500 ease-out ${
        exiting ? "pointer-events-none opacity-0" : "opacity-100"
      }`}
      aria-busy="true"
      aria-label="Φόρτωση"
    >
      <div className="loading-screen-ring-wrap relative flex h-44 w-44 items-center justify-center">
        <svg
          className="absolute h-44 w-44 -rotate-90 text-stone-200"
          viewBox="0 0 160 160"
          aria-hidden
        >
          <circle
            cx="80"
            cy="80"
            r="70"
            fill="none"
            stroke="currentColor"
            strokeWidth="5"
          />
          <circle
            cx="80"
            cy="80"
            r="70"
            fill="none"
            className="text-dragons-red loading-screen-ring stroke-current"
            strokeWidth="5"
            strokeLinecap="round"
            strokeDasharray={439.82}
            strokeDashoffset={439.82}
          />
        </svg>
        <img
          src={LOGO_URL}
          alt=""
          width={112}
          height={112}
          className="relative z-10 h-28 w-28 rounded-full object-cover shadow-lg ring-2 ring-white loading-screen-logo-pulse"
        />
      </div>
      <p className="mt-10 font-oswald text-sm font-medium tracking-[0.35em] text-stone-600 uppercase">
        Dragons Barbershop
      </p>
      <p className="mt-2 font-manrope text-xs text-stone-500">Πάτρα</p>
    </div>
  );
}
